import type { IProposal } from "../../../../types/models/proposals.modals.types";
import { usePutHttp } from "../../http.hook";

interface IBody {
  name: string | undefined;
  brief: string | undefined;
  expectedMetrics: {
    cost: number | undefined;
    views: number | undefined;
    posts: number | undefined;
  } | undefined;
  referenceCreators: Array<string> | undefined;
  notes: string | undefined;
}

interface IResponse {
  proposal: IProposal;
}

export function useUpdateProposalAdminHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/admin/campaigns/proposals/:proposalId",
  });
}
